"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var EventStack_1 = __importDefault(require("../EventStack"));
var uniqueId = require('lodash.uniqueid');
var BASE_ZINDEX = 100;
var zIndexCounter = 0;
var Backdrop = styled_components_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.25);\n  transition: all 0.3s;\n  ", ";\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.25);\n  transition: all 0.3s;\n  ",
    ";\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return isOpen
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          opacity: 1;\n        "], ["\n          opacity: 1;\n        "]))) : styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          pointer-events: none;\n          opacity: 0;\n        "], ["\n          pointer-events: none;\n          opacity: 0;\n        "])));
});
var Overlay = styled_components_1.default('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  ",
    ";\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return !isOpen && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
});
var ZIndexOverlay = styled_components_1.default(Overlay)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  z-index: ", ";\n"], ["\n  z-index: ", ";\n"])), function (_a) {
    var zIndex = _a.zIndex;
    return BASE_ZINDEX + zIndex;
});
var Wrapper = styled_components_1.default('div')(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  margin: 0;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  z-index: 100;\n  border-radius: ", ";\n  ", ";\n  transition: all 0.3s;\n  box-shadow: 0 0 ", " 0 rgba(0, 0, 0, 0.2);\n  ", ";\n  ", "\n"], ["\n  margin: 0;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  z-index: 100;\n  border-radius: ", ";\n  ",
    ";\n  transition: all 0.3s;\n  box-shadow: 0 0 ", " 0 rgba(0, 0, 0, 0.2);\n  ",
    ";\n  ",
    "\n"])), polished_1.rem(4), function (_a) {
    var size = _a.size, theme = _a.theme;
    if (size === 'fullscreen') {
        return styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        max-width: 100%;\n        margin: 0;\n        border-radius: 0;\n        bottom: 0;\n        top: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n      "], ["\n        max-width: 100%;\n        margin: 0;\n        border-radius: 0;\n        bottom: 0;\n        top: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n      "])));
    }
    else if (size === 'xs') {
        return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        top: ", ";\n        max-width: ", ";\n        width: calc(100% - ", ");\n      "], ["\n        top: ", ";\n        max-width: ", ";\n        width: calc(100% - ", ");\n      "])), polished_1.rem(theme.grid.gutterWidth), polished_1.rem(350), polished_1.rem(theme.grid.gutterWidth * 2));
    }
    return styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      top: ", ";\n      max-width: ", ";\n      width: calc(100% - ", ");\n    "], ["\n      top: ", ";\n      max-width: ", ";\n      width: calc(100% - ", ");\n    "])), polished_1.rem(theme.grid.gutterWidth), polished_1.rem(800), polished_1.rem(theme.grid.gutterWidth * 2));
}, polished_1.rem(40), function (_a) {
    var isOpen = _a.isOpen;
    return isOpen
        ? styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n          transform: translateY(0);\n          opacity: 1;\n        "], ["\n          transform: translateY(0);\n          opacity: 1;\n        "]))) : styled_components_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n          transform: translateY(-50px);\n          opacity: 0;\n        "], ["\n          transform: translateY(-50px);\n          opacity: 0;\n        "])));
}, function (_a) {
    var centered = _a.centered;
    if (centered) {
        return styled_components_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n        top: 50%;\n        transform: translateY(-50%);\n      "], ["\n        top: 50%;\n        transform: translateY(-50%);\n      "])));
    }
    return styled_components_1.css(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""])));
});
exports.ModalContent = styled_components_1.default('div')(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  padding: ", "\n    ", ";\n"], ["\n  padding: ", "\n    ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth * 2);
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
});
exports.ModalActions = styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  border-top: ", " solid #eee;\n  padding: ", ";\n  display: flex;\n  justify-content: space-between;\n"], ["\n  border-top: ", " solid #eee;\n  padding: ", ";\n  display: flex;\n  justify-content: space-between;\n"])), polished_1.rem(1), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
});
var element = null;
var modalRoot;
if (typeof document !== 'undefined') {
    element = document.createElement('div');
    element.setAttribute('id', 'modal-root');
    modalRoot = document.body.appendChild(element);
}
var bodyOverflowHiddenClass = 'modal-opened';
var GlobalStyle = styled_components_1.createGlobalStyle(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  body.", " {\n    overflow: hidden;\n  }\n"], ["\n  body.", " {\n    overflow: hidden;\n  }\n"])), bodyOverflowHiddenClass);
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.init = function () {
            document.body.classList.add(bodyOverflowHiddenClass + "-" + _this.uid);
            if (typeof document !== 'undefined') {
                _this.setState({ zIndex: ++zIndexCounter });
                EventStack_1.default.add(document.body, 'keydown', _this.handleKeyDown);
            }
        };
        _this.destroy = function () {
            document.body.classList.remove(bodyOverflowHiddenClass + "-" + _this.uid);
            if (typeof document !== 'undefined') {
                EventStack_1.default.remove(document.body, 'keydown', _this.handleKeyDown);
            }
        };
        _this.handleKeyDown = function (e) {
            var handleClose = _this.props.handleClose;
            if (e.key === 'Escape') {
                handleClose();
            }
        };
        _this.uid = uniqueId();
        _this.state = {
            zIndex: 0,
        };
        _this.el = null;
        if (typeof document !== 'undefined') {
            _this.el = document.createElement('div');
        }
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        modalRoot.appendChild(this.el);
        if (this.props.isOpen === true) {
            this.init();
        }
    };
    Modal.prototype.componentDidUpdate = function (prevProps) {
        if (typeof document !== 'undefined') {
            if (this.props.isOpen === true && prevProps.isOpen === false) {
                this.init();
            }
            if (this.props.isOpen === false && prevProps.isOpen === true) {
                this.destroy();
            }
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        modalRoot.removeChild(this.el);
        this.destroy();
    };
    Modal.prototype.render = function () {
        var _a = this.props, centered = _a.centered, size = _a.size, isOpen = _a.isOpen, children = _a.children, handleClose = _a.handleClose, restProps = __rest(_a, ["centered", "size", "isOpen", "children", "handleClose"]);
        var zIndex = this.state.zIndex;
        return react_dom_1.default.createPortal(React.createElement(ZIndexOverlay, { isOpen: isOpen, zIndex: zIndex },
            React.createElement(Wrapper, __assign({ centered: centered, size: size, isOpen: isOpen }, restProps), children),
            React.createElement(Backdrop, { isOpen: isOpen, onClick: handleClose }),
            React.createElement(GlobalStyle, null)), this.el);
    };
    Modal.defaultProps = {
        size: 'm',
    };
    return Modal;
}(React.PureComponent));
exports.default = Modal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;
